'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _dom_component = require('./component/dom_component');

var _dom_component2 = _interopRequireDefault(_dom_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

/**
 * @fileOverview [description]
 * @author [author]
 * @time [time]
 * @module @tencent/spaui-loading
 */

var setComponentSign = _spauiUtils.utils.setComponentSign;

/**
 * @class
 */
var Loading = function (_PureComponent) {
    _inherits(Loading, _PureComponent);

    /**
     * 属性说明
     * @property {titleline} 全局属性
     * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
     * @property {titleline} 基础属性
     * @property {bool} [show] 是否展示
     * @property {string} [display=''] 展示方式，可选值：inline-block
     * @property {string} [stroke=#0b97ea] type==svg 的loading颜色
     * @property {number} [circleSize=100] type==svg loading圆形的大小
     * @property {number} [delay=0] 延迟展示，毫秒(只执行一次)
     * @property {string} [type='default'] loading类型，目前主要可选值为：type: default，svg，page（default为区域；page为整个页面）
     */
    function Loading(props) {
        _classCallCheck(this, Loading);

        var _this = _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).call(this, props));

        _this.nullList();

        _this.timeout = null;

        _this.state = {
            delayShow: props.delay > 0 ? false : true
        };
        return _this;
    }

    _createClass(Loading, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setShow();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.nullList();
            clearTimeout(this.timeout);
        }
    }, {
        key: 'nullList',
        value: function nullList() {
            this.rootNode = null;
        }
    }, {
        key: 'setShow',
        value: function setShow() {
            var _this2 = this;

            var delayShow = this.state.delayShow;
            var delay = this.props.delay;


            if (delay > 0 && !delayShow) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    _this2.setState({
                        delayShow: true
                    });
                }, delay);
            }
        }
    }, {
        key: 'getDOMNode',
        value: function getDOMNode() {
            return this.rootNode || null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var children = this.props.children;
            var delayShow = this.state.delayShow;


            if (!delayShow) {
                return null;
            }

            return _react2.default.createElement(
                _dom_component2.default,
                _extends({}, this.props, {
                    devProps: [Loading, this.props],
                    htmlRef: function htmlRef(el) {
                        _this3.rootNode = el;
                    }
                }),
                children
            );
        }
    }]);

    return Loading;
}(_react.PureComponent);

// 组件标记与上报


Loading.propTypes = {
    show: _spauiUtils.PropTypes.bool,
    display: _spauiUtils.PropTypes.string,
    type: _spauiUtils.PropTypes.string,
    stroke: _spauiUtils.PropTypes.string,
    circleSize: _spauiUtils.PropTypes.number,
    delay: _spauiUtils.PropTypes.number
};
Loading.defaultProps = {
    type: '',
    display: '',
    stroke: '#0b97ea',
    circleSize: 100,
    delay: 0
};
setComponentSign(Loading, _info2.default);

exports.default = Loading;